// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3BN25","paramInput":"JobSimulator_paramInput__1AEmk","input":"JobSimulator_input__S-nK6"};